import skillsTypes from '../../constants/skillsTypes'
export * from './get'
export * from './create'
export * from './getindex'
// export * from './publish'
// export * from './unpublish'
export * from './update'

const set_skill_errors = (messages) => {
  return {
    type: skillsTypes.set_errors,
    payload: messages
  }
}

const reset_skill = () => {
  return {
    type: skillsTypes.reset
  }
}

export {
  set_skill_errors,
  reset_skill,
}



// WEBPACK FOOTER //
// ./src/js/actions/skills/index.js